import {View} from 'MWC';
import tpl from '../templates/desktop/payment-notice';
import tplMobile from '../templates/mobile/payment-notice';

export default class extends View {
    template = tpl;

    templateMobile = tplMobile;

    constructor() {
        super();
        this.state = {
            ui: this.uiStates.INITIAL
        };
    }
}
